var __vue_script__, __vue_template__
var __vue_styles__ = {}
require("!!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter.js!../../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Dropdown.vue")
__vue_script__ = require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Dropdown.vue")
if (Object.keys(__vue_script__).some(function (key) { return key !== "default" && key !== "__esModule" })) {
  console.warn("[vue-loader] resources/assets/javascript/components/queue/Dropdown.vue: named exports in *.vue files are ignored.")}
__vue_template__ = require("!!vue-html-loader!../../../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Dropdown.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  var id = "_v-5bcffefe/Dropdown.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/javascript/components/queue/Dropdown.vue
// module id = ./resources/assets/javascript/components/queue/Dropdown.vue
// module chunks = 54